<template>
    <div class="flex w-full h-7 rounded-md overflow-hidden">
        <div
            v-for="(segment, i) in segments"
            :key="i"
            class="flex items-center justify-center details font-medium"
            :class="[segment.colorClass, segment.textColorClass]"
            :style="{ width: segment.percent + '%' }"
            :title="`${i + 1}: ${segment.count} (${segment.percent.toFixed(0)}%)`">
            <span v-if="segment.percent >= 6">{{ Math.round(segment.percent) }}%</span>
        </div>
        <div v-if="totalCount === 0" class="flex-1 bg-valence-grey-100"></div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { paletteColor } from "./distributionPalette";

interface Props {
    distribution: number[];
    maxScore?: number | null;
}

const props = defineProps<Props>();

const totalCount = computed(() => props.distribution.reduce((a, b) => a + b, 0));

const segments = computed(() => {
    const total = props.distribution.length;
    return props.distribution.map((count, i) => ({
        count,
        percent: totalCount.value > 0 ? (count / totalCount.value) * 100 : 0,
        colorClass: paletteColor(i, total),
        textColorClass: i === 0 || i === total - 1 ? "text-white" : "text-valence-grey-850",
    }));
});
</script>
